// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WO5L0uygAxShmT {
  right: var(--ds-space-300, 24px);
  bottom: var(--ds-space-200, 16px);
  justify-content: right;
  transition: bottom 0.3s ease-in-out;
}
.WO5L0uygAxShmT.hPIW2k34jTbZL8 {
  bottom: -100px;
}
.qACOJzk6U2R5g_ {
  padding: 0;
  border: none;
}
.VkU_Z9n34LANvo {
  height: 675px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `WO5L0uygAxShmT`,
	"isCardRoute": `hPIW2k34jTbZL8`,
	"buttonGroup": `qACOJzk6U2R5g_`,
	"chatInterfaceContainer": `VkU_Z9n34LANvo`
};
export default ___CSS_LOADER_EXPORT___;
